module.exports = __webpack_public_path__ + "img/qrcode_west.ed958fca.png";